import {config, dom, library} from '@fortawesome/fontawesome-svg-core'
import {
	faArrowDown,
	faArrowLeft,
	faArrowTrendUp,
	faArrowUp,
	faAt,
	faBars,
	faBell,
	faBuilding,
	faCalendarAlt,
	faChartArea,
	faChartBar,
	faChartLine,
	faCheckCircle,
	faCircle,
	faCircleHalfStroke,
	faCircleQuestion,
	faCoins,
	faCreditCard,
	faDesktop,
	faEdit,
	faEuroSign,
	faExchangeAlt,
	faFileArrowDown,
	faFileInvoiceDollar,
	faGauge,
	faHandHoldingHeart,
	faHashtag,
	faHeartPulse,
	faHourglassHalf,
	faIdCard,
	faIndustry,
	faListCheck,
	faMapMarkerAlt,
	faMinus,
	faMoon,
	faPaperPlane,
	faPause,
	faPercent,
	faPlay,
	faPlus,
	faRobot,
	faRotate,
	faShieldAlt,
	faSignOutAlt,
	faSpinner,
	faSun,
	faTimesCircle,
	faTrash,
	faTriangleExclamation,
	faUser,
	faUsers,
	faUserShield,
	faWallet
} from '@fortawesome/free-solid-svg-icons'
import {faBitcoin, faCcMastercard, faCcVisa, faEthereum, faTelegram} from "@fortawesome/free-brands-svg-icons";

config.mutateApproach = 'sync';

library.add(
	faSignOutAlt,
	faUserShield,
	faDesktop,
	faUsers,
	faPlus,
	faEdit,
	faTrash,
	faHashtag,
	faIdCard,
	faAt,
	faTelegram,
	faExchangeAlt,
	faCoins,
	faChartBar,
	faChartArea,
	faChartLine,
	faPercent,
	faMapMarkerAlt,
	faBuilding,
	faRobot,
	faBell,
	faHourglassHalf,
	faHandHoldingHeart,
	faCheckCircle,
	faTimesCircle,
	faUser,
	faIndustry,
	faCreditCard,
	faCcMastercard,
	faCcVisa,
	faCircle,
	faWallet,
	faShieldAlt,
	faCalendarAlt,
	faBitcoin,
	faEthereum,
	faEuroSign,
	faFileInvoiceDollar,
	faPaperPlane,
	faRotate,
	faFileArrowDown,
	faPause,
	faPlay,
	faListCheck,
	faTriangleExclamation,
	faCircleQuestion,
	faSpinner,
	faArrowLeft,
	faArrowUp,
	faArrowDown,
	faArrowTrendUp,
	faBars,
	faCircleHalfStroke,
	faMoon,
	faSun,
	faGauge,
	faHeartPulse,
	faMinus
);

dom.watch();
